import React from "react"

import { Skeleton } from "shared/ui/skeleton/Skeleton"

import { useProductTenderTextContext } from "../ProductTenderTextContext"

export const ProductTenderTextVariantDescription = React.memo(() => {
  const { productInformation, isLoading } = useProductTenderTextContext()

  const show = !!productInformation?.variantDescription || isLoading

  if (!show) return null

  return (
    <div className="product-tender-text__section">
      <h3 className="label label--bold">
        {isLoading ? (
          <Skeleton />
        ) : (
          productInformation?.variantDescription?.label ?? ""
        )}
      </h3>
      <p>
        {isLoading ? (
          <Skeleton count={4} />
        ) : (
          productInformation?.variantDescription?.value ?? ""
        )}
      </p>
    </div>
  )
})

ProductTenderTextVariantDescription.displayName =
  "ProductTenderText.VariantDescription"
